import React from 'react';
import { ConsentPage } from '@repo/customer-registration-kit/signup/components/consent-page/consent-page';
import { useNavigate } from '@repo/poly-hooks/routing';
import { useSegment } from '@repo/poly-hooks/segment';
import { useTrackRender } from '@repo/shared-kit/hooks/use-track-render';
import { getConsentFlow } from 'register-partners-js/utils/consent-ab';

interface ConsentPageRouteProps {
  onBack?: () => void;
  redirectionId?: string;
}

const flow = getConsentFlow({ isPartnerFlow: true });

export function ConsentPageRoute({
  onBack,
  redirectionId,
}: ConsentPageRouteProps): React.ReactElement {
  const segment = useSegment();
  const navigate = useNavigate();

  useTrackRender({
    eventName: 'onboarding_consent_displayed',
    params: { flow },
  });

  const handleContinue = (hasConsent: boolean): void => {
    segment.track('onboarding_consent_confirmed', {
      flow,
      consent_value: hasConsent ? 'opt_in' : 'opt_out',
    });

    const passwordCreationUrl = `/${redirectionId}/password-creation`;
    navigate(passwordCreationUrl);
  };

  return <ConsentPage layout="control" onBack={onBack} onContinue={handleContinue} />;
}
